










































































import { Vue, Component, Ref } from 'vue-property-decorator'
import StudyAnswerMathTextField from '@/components/student/molecules/StudyAnswerMathTextField.vue'
import Tegaki, { Stroke } from '@/components/tegaki/Tegaki.vue'

@Component({
  components: {
    StudyAnswerMathTextField,
    Tegaki,
  },
})
export default class PracticeDummy4 extends Vue {
  @Ref()
  tegaki!: Tegaki

  private isHandInput = true
  private inputText = ''
  private strokeData: Stroke[][] = []

  /**
   * 手書きのストローク情報を更新
   */
  private setStrokeData(strokes: Stroke[][]) {
    this.strokeData = strokes
  }
  /**
   * 入力形式を手書きとソフトウェアキーボードで切り替えた時に入力結果をリセット
   */
  private onChangeIsHandInput() {
    this.inputText = ''
  }
}
